import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import 'amfe-flexible'
import './assets/style/common.scss'
import './assets/style/tjzhwl.scss'
import api from './api/index'
import global from './util/global'

import VueClipboard from 'vue-clipboard3'
VueClipboard.config.autoSetContainer = true

import TopHead from './components/TopHead.vue';//底部菜单栏
import TopHeadText from './components/TopHeadText.vue';//底部菜单栏
import FootTab from './components/FootTab.vue';//底部菜单栏
import sureInput from './components/sureInput.vue';//底部菜单栏
import search from './components/search.vue';//搜索组件
import searchHead from './components/searchHead.vue';//搜索组件
import { Uploader,DropdownMenu, DropdownItem , Image as VanImage ,Rate,  Dialog, Sticky , Collapse, CollapseItem, ActionSheet, Icon, CountDown,  Checkbox, CheckboxGroup, Calendar, Tab, Tabs, PullRefresh, Toast, List, Overlay, Picker, Popup, Swipe, SwipeItem } from 'vant';

const app = createApp(App).use(router);

app.use(VueClipboard);
app.use(Uploader);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Sticky);
app.use(Swipe);
app.use(Rate);
app.use(SwipeItem);
app.use(ActionSheet);
app.use(Icon);
app.use(CountDown);
app.use(Tab);
app.use(Tabs);
app.use(PullRefresh);
app.use(List);
app.use(Overlay);
app.use(Picker);
app.use(Popup);
app.use(Calendar);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(Collapse);
app.use(CollapseItem);
app.use(VanImage);

import bridge from './util/bridge'

app.config.globalProperties.$iosBridge= bridge; // 全局定义ios交互方法
app.config.globalProperties.$global = global; // 全局定义global
app.config.globalProperties.$iosMethod = setupWebViewJavascriptBridge; // 全局定义ios调用方法
app.config.globalProperties.$renderTime = renderTime; // 全局定义修改ios时间格式
app.config.globalProperties.$api = api; // 全局定义api
app.config.globalProperties.$toast = Toast; // 全局定义Toast
app.config.globalProperties.$dialog = Dialog; // 全局定义Toast
app.component('TopHead',TopHead);
app.component('FootTab',FootTab);
app.component('Search',search);
app.component('SureInput',sureInput);
app.component('TopHeadText',TopHeadText);
app.component('SearchHead',searchHead);

app.mount('#app')

function setupWebViewJavascriptBridge(callback) { //ios联通h5的方法
  if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
  if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
}

function renderTime(t) {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf("Linux") > -1;   //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1 || u.indexOf('iPad') > -1 || (/Safari/.test(u) && !/Chrome/.test(u)); //ios终端
  if(isiOS){
    return t.replace(/\-/g,'/')
  }else{
    return t;
  }
}
